import { render, staticRenderFns } from "./reportingBpas.vue?vue&type=template&id=30907cdd&"
import script from "./reportingBpas.vue?vue&type=script&lang=js&"
export * from "./reportingBpas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports